<template>
	<div>
		<!-- 首页导航 -->
		<div class="flex" style="width: 90%;margin:  5px auto;">
			<div class=" iconfont tubiao2" @click="drawer = true" style="font-size: 0.875rem;">菜单</div>
			<div class="icon-denglu-yonghu iconfont tubiao2" @click="urseHead"></div>
		</div>

		<div>
			<el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :direction="direction" style="width: 100%;">
				<div style="padding-top: 10px;">
					<div class="finger2" @click="welcome" :class="myindex == '/welcome-phone'? 'menu-background2':''">欢迎辞</div>

					<div class="finger2" @click="organization" :class="myindex == '/organization-phone'? 'menu-background2':''">组织机构</div>

					<div class="finger2" @click="register" :class="myindex == '/signIn'? 'menu-background2':''">会议回放</div>

					<div class="finger2" @click="schedule" :class="myindex == '/schedule-phone'? 'menu-background2':''">大会日程</div>

					<div class="finger2" @click="goLive" :class="myindex == '/seleteLive'? 'menu-background2':''">下届预告</div>

					<div class="finger2" @click="stay2" :class="myindex == '/stay-phone'? 'menu-background2':''">征文投稿</div>

					<div class="finger2" @click="guide" :class="myindex == '/guide-phone'? 'menu-background2':''">参会指南</div>

					<div class="finger2" @click="download" :class="myindex == '/download-phone'? 'menu-background2':''">资料下载</div>

					<div class="finger2" @click="contact" :class="myindex == '/contact'? 'menu-background2':''">联系我们</div>
					
					<div class="finger2" @click="photoLive" :class="myindex == '/contact'? 'menu-background2':''">照片直播</div>
					
					<div class="finger2" @click="creditState" :class="myindex == '/contact'? 'menu-background2':''">学分说明</div>
					
					<div class="finger2" @click="daily" :class="myindex == '/contact'? 'menu-background2':''">每日会讯</div>
				</div>
			</el-drawer>

		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false,
				direction: 'ltr',
				myindex: ''
			}
		},
		methods: {
			photoLive() {
				window.open("http://live.jfoto.cn/gti/d04d0ea7")
			},
			creditState() {
				window.open('https://view.officeapps.live.com/op/view.aspx?src=' + 'https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%AD%A6%E5%88%86%E8%AF%B4%E6%98%8E.docx')
			},
			daily() {
				this.$router.push({
					path:"/daily"
				})
			
			},
			welcome() {
				this.$router.push({
					path: '/welcome-phone'
				})
			},
			organization() {
				this.$router.push({
					path: '/organization-phone'
				})
			},
			register() {
				window.location.href = "https://app7VA52GBr7813.h5.xiaoeknow.com"
				// if (localStorage.getItem("user")) {
				// 	let form = JSON.parse(localStorage.getItem("user"));
				// 	if (form.user.isonline == "是") {
				// 		this.$message({
				// 			message: '登录成功',
				// 			type: 'success'
				// 		})
				// 		this.$router.push({
				// 			path: '/personalCenter'
				// 		})
				// 	} else {
				// 		if (form.user.IdCard == "" || form.user.IdCard == undefined || form.user.isIdac == undefined) {
				// 			this.dialogVisible = true;
				// 		} else {
				// 			this.$message({
				// 				message: '登录成功',
				// 				type: 'success'
				// 			})
				// 			this.$router.push({
				// 				path: '/personalCenter'
				// 			})
				// 		}
				// 	}
				// } else {
				// 	this.$router.push({
				// 		path: '/seleteSignln'
				// 	})
				// }
			},

			oauth() {
				//    snsapi_base  snsapi_userinfo 第一步用户授权，跳转目标页，在下一页得到code
				let AppId = "wxc17e1b4c4aceccbb"; //公众号的唯一标识,开发者ID
				let score = 'snsapi_userinfo' //这里采用静默登录 //or snsapi_userinfo
				let redirect_urls = encodeURIComponent("http://bisc2021.ganzhiyu.com/index.html#/weixin");
				let urls = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + AppId + "&redirect_uri=" + redirect_urls +
					"&response_type=code&scope=" + score + "&state=STATE#wechat_redirect";
				window.location.href = urls;
			},
			// 判断是否是微信端浏览器
			isWeiXin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true; // 是微信端
				} else {
					return false;
				}
			},

			schedule() {
				this.$router.push({
					path: '/schedule-phone'
				})
			},
			goLive() {
				this.$router.push({
					path:'/LivePage',
					query:{'index':'0'},
				})
				// if (localStorage.getItem("user")) {
				// 	let info = JSON.parse(localStorage.getItem("user"))
				// 	this.$api.getUserLiveUrl({
				// 		phone: info.user.phone
				// 	}, res => {
				// 		if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
				// 			window.location.href = res.data.c
				// 		} else {
				// 			this.$message.error(res.data.rm);
				// 		}
				// 	});
				// } else {
				// 	var r = confirm("您当前没有登录，请先注册会议网站并进行登录，方可观看本次大会直播");
				// 	if (r == true) {
				// 		localStorage.removeItem('user');
				// 		this.$router.push({
				// 			path: '/signIn'
				// 		})
				// 	}
				// }
			},
			stay2() {
				if (localStorage.getItem("user")) {
					this.$router.push({
						path: '/stay-phone'
					});
				} else {
					var r = confirm("您当前没有登录，请先登录，方可进行投稿");
					if (r == true) {
						localStorage.removeItem('user');
						this.$router.push({
							path: '/signIn'
						})
					}
				}
				// this.$router.push({
				//   path: '/stay-phone'
				// })
				// alert("此功能后续开放....")
			},
			guide() {
				this.$router.push({
					path: '/guide-phone'
				})
			},
			download() {
				this.$router.push({
					path: '/download-phone'
				})
			},
			contact() {
				this.$router.push({
					path: '/contact'
				})
			},
			urseHead() {
				if (localStorage.getItem("user")) {
					this.$router.push({
						path: '/personalCenter'
					})
				} else {
					if (this.isWeiXin()) {
						this.oauth();
					} else {
						this.$router.push({
							path: '/seleteSignln'
						})
					}
				}
			}

		},
		mounted() {
			console.log(this)
			this.myindex = this.$route.fullPath
		},
		watch: {
			$route() {
				this.myindex = this.$route.fullPath
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/style/style.scss';

	.el-drawer {
		width: 200px !important;
	}


	.finger2 {
		text-align: center;
		line-height: 40px;
		font-size: 15px;
		color: #666;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.tubiao2 {
		font-size: 20px;
		color: #7c7c7c;
	}

	.menu-background2 {
		background-color: #a4dfff;
		color: #fff;
	}
</style>
